import { frontendURL } from 'dashboard/helper/URLHelper.js';
import {
  LEGACY_AGENT_ONLY_PERMISSIONS,
  QA_DASHBOARD_VIEW_PERMISSIONS,
} from 'dashboard/constants/permissions';
import QaDashboardPageRouteView from './pages/QaDashboardPageRouteView.vue';
import QaTemplateAuditPage from './pages/QaTemplateAuditPage.vue';
import QaCloseTypeAuditPage from './pages/QaCloseTypeAuditPage.vue';
import QaKeywordSearchPage from './pages/QaKeywordSearchPage.vue';

const meta = {
  permissions: {
    anyOf: [
      'administrator',
      LEGACY_AGENT_ONLY_PERMISSIONS,
      QA_DASHBOARD_VIEW_PERMISSIONS,
    ],
  },
};

const qaDashboardRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/qa-dashboard'),
      component: QaDashboardPageRouteView,
      children: [
        {
          path: '',
          redirect: to => ({
            name: 'qa_dashboard_template_audit',
            params: to.params,
          }),
        },
        {
          path: 'template-audit',
          name: 'qa_dashboard_template_audit',
          meta,
          component: QaTemplateAuditPage,
        },
        {
          path: 'close-type-audit',
          name: 'qa_dashboard_close_type_audit',
          meta,
          component: QaCloseTypeAuditPage,
        },
        {
          path: 'keyword-search',
          name: 'qa_dashboard_keyword_search',
          meta,
          component: QaKeywordSearchPage,
        },
      ],
    },
  ],
};

export default qaDashboardRoutes;
